import { Typography } from '@mui/material';
import React, { useState } from 'react';
import {
  Create,
  CreateBase,
  CreateProps,
  DateInput,
  Labeled,
  RadioButtonGroupInput,
  RefreshButton,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  useGetOne,
  useNotify,
  useRecordContext,
  useRedirect,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { PriceField } from '../components/PriceField';
import { Invoice } from '../types';
import InvoiceLinkedContract from './InvoiceLinkedContract';

interface Props extends CreateProps<Invoice> {
  onCancel: () => void;
}

const pnChoices = [
  { _id: 1, type: 'At-Need / Deceased' },
  { _id: 2, type: 'Pre-Need / Not Deceased' },
];

const anChoices = [
  { _id: 1, type: 'At-Need / Deceased' },
];



export const InvoiceCreate = ({ onCancel, ...props }: Props) => {
  const translate = useTranslate();
  const record = useRecordContext();
  const [action, setAction] = useState("withdrawn from");
  
  return (

    <CreateBase {...props}>
    <SimpleForm toolbar={<InvoiceCreateToolbar />}>
      {/* <DateInput source="DueDate" defaultValue={new Date(Date.now() - 30 * 86400000)}/> */}
      <DateInput source="IssueDate" />
      <RadioButtonGroupInput source="Type" choices={record.is_preneed ? pnChoices : anChoices} 
        optionText="type" 
        label="Invoice type to create" 
        optionValue="_id" 
        defaultValue={1} 
        onChange={(e) => {
          if(e.target.value == '1'){
            setAction("withdrawn from");
          }else{
            setAction("deposited into");
          }
        }}/>
      {record.is_preneed ?
        <TextInput source="TrustAmount"label={`Enter the amount being ${action} trust`} fullWidth defaultValue={record.total_amount / 100} />
      : null}
    </SimpleForm>
  </CreateBase>
  );
};

const InvoiceCreateToolbar = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const record = useRecordContext();


  return (
    <Toolbar>
        <SaveButton
          label="Save"
          alwaysEnable={true}
        />
    </Toolbar>
);
}
